export default __webpack_public_path__ + "toolbar-icon.svg";